import { navigate } from 'gatsby';
import filter from 'lodash/filter';
import get from 'lodash/get';
import head from 'lodash/head';
import includes from 'lodash/includes';
import map from 'lodash/map';
import { DataType } from '../../../components/ActivateStore/ActivateStore';
import { formatDate } from '../../../utils/functions';
import { PARTS_NUMBER } from '../../../utils/productType';
import { Ad, PartsAd } from '../Listing/AdList';

const formatterModelName = (model: any) => {
  return `${get(model, 'brandName', '--')} ${get(model, 'name', '--')} ${get(
    model,
    'version',
    '--',
  )}`;
};

const formatterModelYear = (model: any) => {
  return `${get(model, 'fabricationYear', '--')}/${get(model, 'modelYear', '--')}`;
};

const formatterStatus = (status: string) => {
  const newStatus = parseInt(status, 10);
  switch (newStatus) {
    case 0:
      return 'inativo';
    case 1:
      return 'ativo';
    case 2:
      return 'rascunho';
    default:
      return '****';
  }
};
export const statusToNum = (status: string) => {
  switch (status) {
    case 'inativo':
      return 0;
    case 'ativo':
      return 1;
    case 'rascunho':
      return 2;
    default:
      return '****';
  }
};

const formatterDate = (stringDate: string) => {
  return stringDate && stringDate.length
    ? new Date(stringDate).toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
    : '';
};

const formatterStatusColor = (status: string) => {
  const newStatus = parseInt(status, 10);
  switch (newStatus) {
    case 0:
      return 'boulder';
    case 1:
      return 'grass-green';
    case 2:
      return 'blaze-orange';
    default:
      return 'boulder';
  }
};
const getThumbUrl = (photoUrl: string[]) => {
  const thumbUrl = head(photoUrl);
  return thumbUrl;
};
export const adapterAdList = (
  data: any,
  isAdmin: boolean,
  control: (
    done: 'done' | 'openModal' | 'changeStatus',
    id: number,
    newStatus: number,
    defaultPlan: string,
  ) => void | Promise<void>,
  storeControl: (newStatus: number) => Promise<void>,
  typeSearch: any,
): {
  active: Ad[] | PartsAd[];
  draft: Ad[] | PartsAd[];
  isAdmin: boolean;
  control: (
    done: 'done' | 'openModal' | 'changeStatus',
    id: number,
    newStatus: number,
    defaultPlan: string,
  ) => void | Promise<void>;
  storeControl: (newStatus: number) => Promise<void>;
} => {
  let formattedAdList = null;

  if (typeSearch !== PARTS_NUMBER) {
    formattedAdList = map(data, item => {
      const {
        model,
        price,
        status,
        photoUrl,
        id,
        create_date,
        plan,
        views,
        proposals,
        plate,
        wppViews,
      } = item;
      return {
        title: formatterModelName(model),
        thumbUrl: getThumbUrl(photoUrl),
        createdAt: formatterDate(create_date),
        value: price,
        year: formatterModelYear(model),
        adStatus: formatterStatus(status),
        statusColor: formatterStatusColor(status),
        views,
        contacts: proposals,
        adCode: id,
        plan,
        type: model.type,
        plate,
        wppViews,
      } as Ad;
    });
  } else {
    formattedAdList = map(data, item => {
      const { price, status, photoUrl, id, plan, newPart, type, name, createDate } = item;
      return {
        title: name,
        thumbUrl: getThumbUrl(photoUrl),
        value: price,
        adStatus: formatterStatus(status),
        statusColor: formatterStatusColor(status),
        adCode: id,
        plan,
        newPart,
        createdAt: formatterDate(createDate),
        type: type === '0' ? PARTS_NUMBER : parseInt(type, 10),
      } as PartsAd;
    });
  }

  const active: any = filter(
    formattedAdList,
    (item: any) => item.adStatus === 'ativo' || item.adStatus === 'inativo',
  );
  const draft: any = filter(formattedAdList, (item: any) => item.adStatus === 'rascunho');

  return { active, draft, isAdmin, control, storeControl };
};
export const formatPlanInformation = (data: any) => {
  const date = formatDate(get(data, 'date', ''));
  const id = get(data, 'id', 0);
  const reference = get(data, 'reference', '');
  const statusNumber = get(data, 'status', '0');
  const status = statusNumber === '0' || statusNumber === 0 ? 'inativo' : 'ativo';
  const information: DataType = {
    date,
    id,
    reference,
    status,
  };
  return information;
};
export const informationEmpty: DataType = {
  id: '',
  date: '00/00/00',
  status: 'ativo',
  reference: '',
};

const formatSubMenuItems = (data: any) =>
  data.map(({ name, type, url }: { name: string; type: number; url: string }) => ({
    value: type,
    label: name,
    url,
    action: () => {
      navigate(url);
    },
  }));

const getMyAccountSubMenu = (nodes: any) => {
  if (!nodes || nodes.length === 0) {
    return [];
  }
  const { submenu_minha_conta } = nodes[0];
  return submenu_minha_conta;
};

export const getVehicleTypes = (data: any) => {
  const { item_submenu } = getMyAccountSubMenu(data).filter(
    ({ url_submenu_minha_conta }: { url_submenu_minha_conta: string }) =>
      includes(url_submenu_minha_conta, 'meus-anuncios'),
  )[0];
  if (item_submenu) {
    return formatSubMenuItems(item_submenu);
  }
  return [];
};

export const formatAsideMenu = (
  data: any,
  onLogout: () => void,
  selectedVehicle: number | undefined,
  isAdmin?: boolean,
) => {
  const menuItems = getMyAccountSubMenu(data).map(
    ({
      icon_submenu_minha_conta,
      item_submenu,
      item_submenu_minha_conta,
      url_submenu_minha_conta,
    }: any) => {
      let action = () => {
        navigate(url_submenu_minha_conta);
      };
      let subMenuItems = null;
      let show = true;
      let selectedSubMenuItem;
      if (includes(url_submenu_minha_conta, 'meus-anuncios')) {
        subMenuItems = formatSubMenuItems(item_submenu);
        selectedSubMenuItem = selectedVehicle;
      }
      if (includes(url_submenu_minha_conta, 'logout')) {
        show = !isAdmin;
        action = onLogout;
      }
      return {
        icon: icon_submenu_minha_conta,
        text: item_submenu_minha_conta,
        show,
        action,
        item_submenu,
        subMenuItems,
        selectedSubMenuItem,
        url: url_submenu_minha_conta,
      };
    },
  );

  const hasIntegrators = menuItems.some(({ url }: { url: string }) =>
    includes(url, 'integradores'),
  );
  if (!hasIntegrators) {
    const integratorsItem = {
      icon: 'SvgIconEdit',
      text: 'Integradores',
      show: true,
      action: () => navigate('/integradores'),
      item_submenu: [],
      subMenuItems: null,
      selectedSubMenuItem: undefined,
      url: '/integradores',
    };
    const logoutIndex = menuItems.findIndex(({ url }: { url: string }) => includes(url, 'logout'));
    if (logoutIndex > -1) {
      menuItems.splice(logoutIndex, 0, integratorsItem);
    } else {
      menuItems.push(integratorsItem);
    }
  }

  return menuItems;
};
